<template>
  <!-- 新增日志 -->
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="650px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="from-body">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="auto"
        class="demo-ruleForm"
        :rules="rules"
      >
      <!-- 日志类别 -->
        <el-form-item :label="$t('pages.system.text55')" prop="apiName">
          <el-select
            v-model="ruleForm.apiName"
            clearable
            :placeholder="$t('pages.system.text55')"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 操作内容 -->
        <el-form-item :label="$t('pages.system.text56')" prop="apiInfo">
          <el-input v-model="ruleForm.apiInfo" style="width: 400px"></el-input>
        </el-form-item>
        <!-- URL -->
        <el-form-item label="URL" prop="requestUrl">
          <el-input
            v-model="ruleForm.requestUrl"
            style="width: 400px"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t("button.cancel") }}</el-button>
      <el-button type="primary" @click="submitForm">{{
        $t("button.determine")
      }}</el-button>
    </span>
  </el-dialog>
</template>


<script>
export default {
  data() {
    return {
      ruleForm: {
        apiName: "", // 日志类别
        apiInfo: "", // 操作内容
        requestUrl: "", // 请求地址
      },
      title: this.$t("pages.system.text62"),
      rules: {
        apiName: [
          {
            required: true,
            message: this.$t("button.pleaseSelect"), //请选择
            trigger: "blur",
          },
        ],
        apiInfo: [
          {
            required: true,
            message: this.$t("pages.system.text64"), //请输入操作内容
            trigger: "change",
          },
          {
            min: 1,
            max: 32,
            message: this.$t("pages.equipment.text219"), //请输入32字以内，唯一不重复,支持大小写字母，数字，下划线等
            trigger: "blur",
          },
        ],
        requestUrl: [
          {
            required: true,
            message: this.$t("pages.system.text65"), //请输入操作地址
            trigger: "blur",
          },
          {
            min: 1,
            max: 200,
            message: "",
            trigger: "blur",
          },
        ],
      },
    };
  },
  //监听判断打开新增或编辑弹窗
  watch: {
    dialogVisible(newValue) {
      if (newValue) {
        this.ruleForm.apiName = "";
        this.ruleForm.apiInfo = "";
        this.ruleForm.requestUrl = "";
        this.ruleForm.id = "";
        if (this.isAdd == 1) {
          this.title = this.$t("pages.system.text62"); //新增日志信息
        } else if (this.isAdd == 2) {
          this.title = this.$t("button.edit"); //编辑
          this.ruleForm.id = this.currentRole.id;
          this.ruleForm.apiName = this.currentRole.apiName;
          this.ruleForm.apiInfo = this.currentRole.apiInfo;
          this.ruleForm.requestUrl = this.currentRole.requestUrl;
        }
      }
    },
  },
  props: ["dialogVisible", "isAdd", "currentRole", "options"],
  methods: {
    // 取消
    handleClose() {
      this.ruleForm = {
        apiName: "",
        apiInfo: "",
        requestUrl: "",
      };
      this.$refs["ruleForm"].resetFields();
      this.$emit("dialogClose");
    },
    // 确定
    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.isAdd == 1) {
            this.request.apiAdd(this.ruleForm).then(() => {
              this.$message.success(this.$t("public.text8")); //新增成功
              this.$emit("apiList");
              this.handleClose();
            });
          } else {
            this.request.apiEdit(this.ruleForm).then(() => {
              this.$message.success(this.$t("public.text9")); //修改成功
              this.$emit("apiList");
              this.handleClose();
            });
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.from-body {
  padding: 0 40px;
  box-sizing: border-box;
  width: 100%;
}
</style>